import PropTypes from 'prop-types'
import React from 'react'
import { DragSource } from 'react-dnd'
import userDragType from 'components/User/dragType'

export class DraggableUser extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,

    id: PropTypes.number,
    profileKey: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }

  render () {
    let {
      children,

      ...props
    } = this.props

    return children(props)
  }
}

const dragSource = {
  beginDrag (props) {
    return {
      id: props.id,
      profileKey: props.profileKey,
      name: props.name
    }
  }
}

export default DragSource(userDragType, dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview()
}))(DraggableUser)
